import React from "react";
import styled from "styled-components";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import EstateFilter from "./EstateFilter";

const EstateFilterModal = ({ isOpen, handleClose }) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          marginRight: "20px",
          height: "fit-content",
          top: "unset",
        },
      }}
      slotProps={{
        root: {
          style: {
            display: "flex",
            alignItems: "center",
          },
        },
      }}
    >
      <StyleWrapper className="d-flex justify-content-end">
        <IconButton
          className="close-btn"
          aria-label="Fermer"
          onClick={handleClose}
          disableRipple
        >
          <CloseIcon />
        </IconButton>
      </StyleWrapper>
      <EstateFilter closeModal={handleClose} />
    </Drawer>
  );
};

const StyleWrapper = styled.div`
  margin-top: 20px;
  margin-right: 20px;

  .close-btn {
    background-color: var(--menu-link-color);
    width: 20px;
    height: 20px;

    svg {
      width: 15px;
      color: var(--white);
    }
  }
`;

export default EstateFilterModal;
